import { Link } from "react-router-dom";
import { NotFoundIcon } from "../components/ui/Icons";
import { Page } from "../components/ui/Page";
import { usePanelPath } from "../routing";

export default () => {
  const panelPath = usePanelPath();
  return (
    <Page>
      <div className="completion-wrap">
        <div className="screenout-icon">
          <NotFoundIcon />
        </div>
        <h2
          style={{
            color: "var(--red)",
            fontFamily: "var(--font-h)",
            fontSize: 26,
            fontWeight: 600,
          }}
        >
          Page not found
        </h2>
        <p
          style={{
            color: "var(--sand)",
            fontSize: 14,
            lineHeight: 1.6,
            margin: "8px 0 22px",
          }}
        >
          It looks like we had a problem finding the right page. Please check
          your link and try again.
        </p>
        <Link className="btn btn-outline btn-full" to={panelPath("/")}>
          Back to dashboard
        </Link>
      </div>
    </Page>
  );
};
